export default {
  userStats: {},
  ranking: [],
}
